export default {
  userStats: {},
  ranking: [],
}
